export default __webpack_public_path__ + "static/media/BGPicture.5b763a2d.png";